var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"no-data text-center my-3"},[_c('img',{staticClass:"img",attrs:{"src":_vm.asset('no-data.png'),"alt":""}}),_c('div',{staticClass:"h3",domProps:{"innerHTML":_vm._s(_vm.message)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }